var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":this.$route.params.routerSettings.id,"data-dqs-request-id":this.$route.params.routerSettings.requestId,"data-start-route":this.$route.params.routerSettings.name}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }